"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("@insolus/prop-types"));

var _invariant = _interopRequireDefault(require("invariant"));

var _Header = _interopRequireDefault(require("./Header"));

var _Pane = _interopRequireDefault(require("./Pane"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var getDefaultActiveKey = function getDefaultActiveKey(props) {
  var activeKey = null;
  React.Children.forEach(props.children, function (child) {
    if (child && !activeKey) {
        activeKey = child.key;
      }
  });
  return activeKey;
};

var Tabs = function (_React$Component) {
  (0, _inherits2.default)(Tabs, _React$Component);

  var _super = _createSuper(Tabs);

  function Tabs(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Tabs);
    _this = _super.call(this, props);

    _this.handleTabClick = function (key) {
      var _next = function _next() {
        if (_this.props.onTabClick) {
          _this.props.onTabClick(key);
        }
      };

      if (_this.props.activeKey === undefined) {
        _this.setState({
          activeKey: key
        }, _next);
      } else {
        _next();
      }
    };

    var activeKey;

    if (props.activeKey !== undefined) {
      activeKey = props.activeKey;
    } else if (props.defaultActiveKey !== undefined) {
      activeKey = props.defaultActiveKey;
    } else {
      activeKey = getDefaultActiveKey(props);
    }

    _this.state = {
      activeKey: activeKey
    };
    return _this;
  }

  (0, _createClass2.default)(Tabs, [{
    key: "_generateTabs",
    value: function _generateTabs() {
      var activeKey = this.state.activeKey;
      var _this$props = this.props,
          children = _this$props.children,
          staticPanes = _this$props.static;
      var tabs = [];
      var content = [];
      var hasActiveChild = false;
      React.Children.forEach(children, function (child) {
        if (!child) {
          return;
        }

        var key = child.key;
        var _child$props = child.props,
            title = _child$props.title,
            hasError = _child$props.hasError,
            origClassName = _child$props.className;
        (0, _invariant.default)(key, "Chaque `<Tabs.Pane>` devrait avoir une cl\xE9 `key` de d\xE9finie.");
        tabs.push({
          key: key,
          title: title,
          hasError: hasError
        });
        var className = (0, _classnames.default)(origClassName, 'Tabs__pane', {
          'Tabs__pane--active': key === activeKey
        });

        if (staticPanes || !hasActiveChild && key === activeKey) {
          content.push(React.cloneElement(child, {
            className: className
          }));

          if (key === activeKey) {
            hasActiveChild = true;
          }
        }
      });
      return {
        tabs: tabs,
        content: content
      };
    }
  }, {
    key: "render",
    value: function render() {
      var activeKey = this.state.activeKey;
      var className = this.props.className;

      var _this$_generateTabs = this._generateTabs(),
          tabs = _this$_generateTabs.tabs,
          content = _this$_generateTabs.content;

      return React.createElement("div", {
        className: (0, _classnames.default)(className, 'Tabs')
      }, React.createElement(_Header.default, {
        items: tabs,
        onTabClick: this.handleTabClick,
        activeKey: activeKey
      }), React.createElement("div", {
        className: "Tabs__content",
        role: "tabpanel"
      }, content));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref, state) {
      var activeKey = _ref.activeKey;

      if (activeKey !== undefined && activeKey !== state.activeKey) {
        return {
          activeKey: activeKey
        };
      }

      return null;
    }
  }]);
  return Tabs;
}(React.Component);

Tabs.Header = _Header.default;
Tabs.Pane = _Pane.default;
Tabs.defaultProps = {
  static: false,
  activeKey: undefined,
  defaultActiveKey: undefined,
  onTabClick: undefined,
  className: undefined
};
var _default = Tabs;
exports.default = _default;